import {
 RssContent
} from '../models';

const mapParagraphRelationships = (obj, included) => {

  return Object.keys(obj).flatMap((key) => {
    const item = obj[key];

    return included.flatMap((meta) => {

      if (item.data.id === meta.id) {

        return {
          defaultImage: meta.attributes?.uri?.url
        };
      }
      return [];
    });
  });
};

const mapRelationships = (obj, included) => {
  return Object.keys(obj).flatMap((key) => {
    const item = obj[key];

    return item.data.flatMap((rel) => {
      return included.flatMap((meta) => {

        if (rel.id === meta.id) {
          return {
            id: meta.id,
            type: meta.type,
            field: key,
            name: meta.attributes?.field_company?.value,
            url: meta.attributes?.field_feed_url?.uri,
            ...mapParagraphRelationships(meta.relationships, included)?.[0]
          };
        }
        return [];
      });
    });
  });
};

export const mapRssContent = (result) => {

  return result.data
    .map((item) => {
      return {
        attributes: {
          ...item.attributes,
          relationships: mapRelationships(item.relationships, result.included),
          id: item.id
        }
      };
    })
    .map((content) => {
      return new RssContent(content).mapToStandard();
    });
};
